import { useSnackbar } from 'notistack';
import { ConfirmDialog } from 'components';
import apiService from 'library/api-service';
import { FormattedMessage } from 'react-intl';
import { Dispatch, SetStateAction, useState } from 'react';
import { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-premium';

type DeleteEffortContactDialogProps = {
  open: boolean;
  effortContactId: GridRowId;
  handleClose: () => void;
  refresh: () => Promise<void>;
  setRowSelectionModel: Dispatch<SetStateAction<GridRowSelectionModel>>;
};

const DeleteEffortContactDialog = ({
  open,
  effortContactId,
  handleClose,
  refresh,
  setRowSelectionModel,
}: DeleteEffortContactDialogProps) => {
  // other hooks
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    try {
      setLoading(true);

      const response = await apiService.deleteEffortContact(Number(effortContactId));

      if (response.isSuccess) {
        enqueueSnackbar(
          <FormattedMessage
            id="effortContacts.deleteEffortContactCompleted"
            defaultMessage="Seçili Efor Muhatabını silme işlemi başarıyla tamamlandı."
          />,
          { variant: 'success' }
        );
        handleClose();
        setRowSelectionModel([]);
        refresh();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmDialog
      open={open}
      title={<FormattedMessage id="effortContacts.deleteEffortContact" defaultMessage="Efor Muhatabı Sil" />}
      description={
        <FormattedMessage
          id="effortContacts.deleteEffortContactRepeat"
          defaultMessage="Bu işlem onaylandıktan sonra Efor Muhatabı veritabanından silinecektir. Silme işlemini onaylıyor musunuz?"
        />
      }
      onClose={handleClose}
      onConfirm={handleDelete}
      loading={loading}
      mobileFullScreen={false}
    />
  );
};

export default DeleteEffortContactDialog;
